import { render } from "./ProductTable.vue?vue&type=template&id=38a313d7"
import script from "./ProductTable.vue?vue&type=script&lang=js"
export * from "./ProductTable.vue?vue&type=script&lang=js"

import "./ProductTable.vue?vue&type=style&index=0&id=38a313d7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__